"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _expander = _interopRequireDefault(require("../expander"));
var _heading = _interopRequireDefault(require("../heading"));
var _icon = _interopRequireDefault(require("../icon"));
var _caretDown = _interopRequireDefault(require("../../icons/caret-down"));
require("./caret-expander.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
  A styled expander that utilizes IconButton and a Heading to open and close expanded content. Expander defaults as closed. Caret button may be positioned on the left or right.
  *
*/
var CaretExpander = function CaretExpander(_ref) {
  var _ref$caretPosition = _ref.caretPosition,
    caretPosition = _ref$caretPosition === void 0 ? 'right' : _ref$caretPosition,
    children = _ref.children,
    className = _ref.className,
    _ref$expandedByDefaul = _ref.expandedByDefault,
    expandedByDefault = _ref$expandedByDefaul === void 0 ? false : _ref$expandedByDefaul,
    expanderId = _ref.expanderId,
    headingProps = _ref.headingProps,
    headingText = _ref.headingText,
    headingWrapperClassName = _ref.headingWrapperClassName,
    iconClassName = _ref.iconClassName,
    _ref$parentTagName = _ref.parentTagName,
    ParentTagName = _ref$parentTagName === void 0 ? 'div' : _ref$parentTagName;
  // if the consumer didn't pass in an id we initialize with a static string
  var _useState = (0, _react.useState)(expanderId !== null && expanderId !== void 0 ? expanderId : 'caretExpander'),
    _useState2 = _slicedToArray(_useState, 2),
    expanderControlsId = _useState2[0],
    setExpanderControlsId = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!expanderId) {
      // If the consumer is not controlling the id,
      // make the id unique only on the client to avoid DOM mismatch if server rendering
      setExpanderControlsId((0, _uniqueId2["default"])('caretExpander'));
    }
  }, []);
  var _useState3 = (0, _react.useState)(expandedByDefault),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  return /*#__PURE__*/_react["default"].createElement(ParentTagName, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_heading["default"], headingProps, /*#__PURE__*/_react["default"].createElement("button", {
    "aria-controls": expanderControlsId,
    "aria-expanded": isExpanded,
    className: (0, _classnames["default"])('flex width-100 items-center', _defineProperty({
      'justify-between': caretPosition === 'right',
      'justify-start': caretPosition === 'left'
    }, headingWrapperClassName, headingWrapperClassName)),
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, headingText), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: (0, _classnames["default"])('sb-caret-expander__icon', _defineProperty({
      ml2: caretPosition === 'right',
      'mr2 order-first': caretPosition === 'left',
      'sb-caret-expander--expanded': isExpanded
    }, iconClassName, iconClassName)),
    path: _caretDown["default"],
    size: "32px"
  }))), /*#__PURE__*/_react["default"].createElement(_expander["default"], {
    expandEffect: "pushdown",
    id: expanderControlsId,
    isExpanded: isExpanded
  }, children));
};
CaretExpander.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Whether the caret is on the left or right. Left may be better
   * to make it clear the element is expandable,
   * especially if the column is wide.
   */
  caretPosition: _propTypes["default"].oneOf(['left', 'right']),
  /** Content to render once expanded. Should be valid JSX or HTML.
   */
  children: _propTypes["default"].node,
  /** Styling applied to the top level parent */
  className: _propTypes["default"].string,
  /** The text for the heading. Can be a string or component, is wrapped in a `Heading` component.
   */
  /** A boolean that determines if the expander starts out open or closed */
  expandedByDefault: _propTypes["default"].bool,
  headingText: _propTypes["default"].any,
  /** Props to pass through to `Heading`, including `tagName`, `size`, `className`, etc. See `Heading` for more info.
   */
  headingProps: _propTypes["default"].shape({
    tagName: _propTypes["default"].any,
    size: _propTypes["default"].string
  }),
  /** Applied to parent of the heading text */
  headingWrapperClassName: _propTypes["default"].string,
  /** Applied to caret icon */
  iconClassName: _propTypes["default"].string,
  /** Creates a div by default, customizable for creating lists, etc. */
  parentTagName: _propTypes["default"].string
} : {};
CaretExpander.displayName = 'CaretExpander';
var _default = exports["default"] = CaretExpander;